import { requestResults } from "../results/actions";

export const searchRequestMiddleware = () => store => next => action => {
  
  next(action);

  const { meta: { requestSearchResults } = {} } = action;

  if(requestSearchResults){
    store.dispatch(requestResults());
  }
}